import React from 'react';
import cn from 'classnames';

import styles from './Myths.scss';

const Myths = () => (
  <div className={cn('row')}>
    <div className={cn('col s12', styles.sportsWeSupport)}>

      <div className={styles.bigHeader}>COLLEGE FOOTBALL RECRUITING MYTHS:</div>
      <div className={styles.darkHeader}>MYTH:</div>
      <div className={styles.desc}>
          I Don&apos;t Need A Recruiting Service.
          I&apos;m Already Getting Emails or Mail From a College Coach.
      </div>
      <div className={styles.darkHeader}>FACT:</div>
      <div className={styles.desc}>
            Every season college football programs will send out
            10,000 to 20,000 letters to future prospects.
            College coaches and Graduate Assistants will
            watch 2,000 to 5,000 videos. They&apos;ll call 200 to
            1,000 football players they want to recruit.
            Next, college coaches will &quot;Verbally Offer&quot; 50
            to 200 players a scholarship. Then, college coaches
            extend up to 80 players a paid &quot;Official Campus Visit&quot;.
            Finally, a college football team will only sign 25 players.
            This is why it&apos;s important to start early! Once a coach fulfills
            his need at your position they&apos;re done looking in your class.<br /> <br />

        <span className={styles.darkHeaderSmall}>
                College Football Recruiting Filter:
            </span><br />
            20,000 Football Recruits<br />
            5,000 Football Recruiting Videos<br />
            1,000 Phone Calls<br />
            200 Verbal Offers<br />
            80 Paid Campus Visits<br />
            25 Football Scholarships<br />
      </div>
      <div className={styles.darkHeader}>MYTH:</div>
      <div className={styles.desc}>
            I Can Wait Until My Senior Year To Start The RecruitIng Process.
        </div>
      <div className={styles.darkHeader}>FACT:</div>
      <div className={styles.desc}>
            One of the worst mistakes you can make is starting
            the recruiting process during your senior year.
            Most college coaches want to build relationships
            with future prospects as early as their freshman
            year or even in middle school. The earlier you join
            MyRecruitBoard the more offers you&apos;ll receive.
            The ultimate goal of starting the recruiting process
            early is to get the most scholarship money possible
            to pay for college. Starting your recruitment during
            your senior year doesn&apos;t mean you won&apos;t get recruited
            it only means you will have to work smarter & harder.
            We can solve your late recruitment needs with our scientific recruiting tools.
        </div>
      <div className={styles.darkHeader}>MYTH:</div>
      <div className={styles.desc}>
            My Coach Will Get Me A Scholarship. I Play On The Best Team In My State.

        </div>
      <div className={styles.darkHeader}>FACT:</div>
      <div className={styles.desc}>
            Coaches can or cannot be part of your recruiting process.
            We&apos;ve helped football players every year who&apos;s high school
            coach had no idea they were being recruited. Sadly,
            there are coaches who don&apos;t care to help every player on
            their team get recruited. One of the problems with playing on
            a Power-House high school team is a college coaches doesn&apos;t
            know how good you are versus how well coached your team is.
            Don&apos;t expect anyone to care more about your dream to play college
            football than you. Your coach’s paid job is to coach your football
            team not to personally find you an athletic scholarship. We have more
            connections and resources than your high school coach period, hands down!
            We are a nationally recognized football recruiting service. College coaches
            use us because were not partial or biased like many high school coaches who
            want to say &quot;I coached that kid&quot;. We connect you with college football teams
            that are a good fit for you. Your high school coach doesn&apos;t have the time or
            resources that we have to help every player with their specific recruiting needs.
            You and your parents have to take ownership of your college football recruiting process.
        </div>
      <div className={styles.darkHeader}>MYTH:</div>
      <div className={styles.desc}>
            Football Recruiting is Expensive & My Coach Said I Don&apos;t Need It.
        </div>
      <div className={styles.darkHeader}>FACT:</div>
      <div className={styles.desc}>
            We know Private Coaches, Trainers, Camps, and 7on7
            teams are important for you to reach your full potential,
            but none of these can guarantee you will get recruited.
            College coaches use their own football camps and clinics to evaluate players.
            For the thousands of players they can&apos;t see in person college
            coaches use trusted recruiting services like MyRecruitBoard.
            Don’t be fooled into thinking if you spend lots of money on
            a private exposure camp or combine you will be recruited.
            We only advise attending college football camps for recruiting exposure.
        </div>
      <div className={styles.darkHeader}>MYTH:</div>
      <div className={styles.desc}>
            A College Coach Will Contact Me First.
        </div>
      <div className={styles.darkHeader}>FACT:</div>
      <div className={styles.desc}>
            One of the biggest mistakes football players do in the college
            recruiting process is believing a college coach will find you.
            College Coaches will not find you, you have to be seen or shown to them.
            Every year very talent players go under-recruited or not recruited at all.
            Playing hard and posting film on Hudl doesn&apos;t mean a coach will
            recruit you. Unless you are one of the top 500 football players
            in America, you will most likely be unnoticed or lost in the college
            football recruiting filter by college coaches.
        </div>
      <div className={styles.darkHeader}>MYTH:</div>
      <div className={styles.desc}>
            I Don&apos;t Need a Video Because My Coach or Someone I Know Has Connections.
        </div>
      <div className={styles.darkHeader}>FACT:</div>
      <div className={styles.desc}>
            Most college coaches can&apos;t afford to attend any games of the
            player they are recruiting. Moreover, if a college coach is
            talking to your coach he&apos;s most likely talking to every other
            coach in your team&apos;s conference not just your head coach.
            Use MyRecruitBoard to get your video seen by every college in
            America you match. <br />
            Here are some video tips:<br />
            Best Highlights 1st - Show your best plays first!<br />
            Keep it Short – Two-three minutes maximum!<br />
            Video Quality - Only use high quality footage!<br />
      </div>
      <div className={styles.darkHeader}>MYTH:</div>
      <div className={styles.desc}>
            College Coaches Don&apos;t Want To Be Contacted First.
        </div>
      <div className={styles.darkHeader}>FACT:</div>
      <div className={styles.desc}>
            College coaches love and get excited when they are contacted
            by a good fit for their program first. Many players look
            down upon certain levels of play or won&apos;t return a message
            to a coach at certain colleges. We highly advise you to always
            reply to a college coach proptly. Always remember until you
            sign a National Letter of Intent nothing is certain!
        </div>
      <div className={styles.darkHeader}>MYTH:</div>
      <div className={styles.desc}>
            I Need A Full Football Scholarship.
        </div>
      <div className={styles.darkHeader}>FACT:</div>
      <div className={styles.desc}>
            Only NCAA D1 FBS football programs are required to give full football
            scholarships. NCAA D1 FCS, NCAA Division II, NAIA and Junior
            colleges offer partial scholarships typically ranging from 25%
            to 75%. 100% scholarships at these levels are very competitive.
            NCAA Division III schools don&apos;t offer football scholarships,
            but they do offer very competitive academic scholarships.
            Being a good fit academically as well as a football player will get you
            lots of scholarship money in NCAA D3. Many times more than any other level
            of play for most football players. The number one reason to join MyRecruitBoard
            is to get the most scholarship funds possible to pay for the high cost of college.
        </div>
      <div className={styles.darkHeader}>MYTH:</div>
      <div className={styles.desc}>
            I&apos;m a Good Football Player and I Have The Size, Speed, & Body Type.
        </div>
      <div className={styles.darkHeader}>FACT:</div>
      <div className={styles.desc}>
            There are thousands of football players every year who don&apos;t get
            recruited or go under-recruited because they didn&apos;t use MyRecruitBoard.
            Likewise, there are thousands of football players every year who don&apos;t
            get recruited because they have severely limited their college football choices.
            Please remember just because you&apos;re good
            doesn&apos;t mean a college coach can&apos;t
            find a player like yourself somewhere else in the country.
            College football coaches have very limited football recruiting budgets.
            They won&apos;t travel around the country looking for you.
            Coaches use MyRecruitBoard and trust the prospects we
            present to them. If you wait to get recruited it may never happen,
            even if you are the Man! Juniors and seniors if you aren&apos;t being
            recruited or you are under-recruited you need to join MyRecruitBoard ASAP!
            If you don&apos;t you risk losing thousands of dollars in college scholarship money.
    </div>
    </div>
  </div>
);


export default Myths;



// WEBPACK FOOTER //
// ./src/components/Myths/Myths.js